import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_soap_7: FaireProductEntity = {
  token: "nyc-soap-7",
  type: "product",
  name: "Honey Almond Body Wash",
  brandName: "Sweet Suds",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4aa8337171d9d3ec324284e579378ad76d6ddb6e24655db3031f2e985093ac30.webp",
  priceDollars: 18,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/4aa8337171d9d3ec324284e579378ad76d6ddb6e24655db3031f2e985093ac30.webp",
  weight: 0.3,
  dimensions: {
    width: 2,
    height: 5,
    depth: 2,
  },
  description: "Luxury hand cream from East Village",
  categoryTokens: ["cat_bath-all"],
  tags: ["nyc-local", "premium", "organic", "manhattan"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
